// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__dJLpS","selects":"Documents_selects__2XIE0"};